module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать клиента\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'apartment-client-details',
        params: {
          client_id: _vm.client.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям клиента")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.client.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteClient.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить клиента")]) : _vm._e()]), _vm._v(" "), _c('client-edit-form', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1624e617","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/ClientEdit.vue
// module id = 586
// module chunks = 0